import { Injectable } from '@angular/core';

import { IBetslipState } from '../../../../../base/store/state';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { isValidTimeOfDay } from '../../../validators';
import { CriteriaValidatorBase } from '../criteria-validator-base.service';

@Injectable()
export class TimeOfDayValidatorService extends CriteriaValidatorBase<IRewardToken, CriteriaType, IBetslipState> {
    override type = CriteriaType.DayOfWeek;

    constructor() {
        super();
    }

    isValid(token: IRewardToken, _: IBetslipState): boolean {
        return isValidTimeOfDay(token);
    }
}
